import Controller from "./pricingConfiguration.controller";
import template from "./pricingConfiguration.html";

const pricingConfiguration = {
  template,
  controller: Controller,
  bindings: {
    updateMethod: "<",
    pricingParameters: "<",
    currency: "<",
    // For City Display
    cityPricing: "<",
    // For Schedules Display
    schedule: "<",
    scheduleIndex: "<",
    resetMethod: "<",
    resetMethodNewSchedule: "<",
    hideEdit: "<",
  },
};

export default pricingConfiguration;



// WEBPACK FOOTER //
// ./src/components/pricingConfiguration/pricingConfiguration.component.js